const baseUrl = 'https://inwaybelief.com';
// https://inwaybelief.com
const host = `${baseUrl}/prod-api`;
let checkQiehuan = false
export default{
    host,    //地址
    checkQiehuan,
    baseUrl
}